function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("defs", null, React.createElement("style", null, ".frame,.primary{fill:none;}.white{fill:#fff;}.highlights{fill:#e8dbec;}.primary{stroke:#4f4954;stroke-linecap:round;stroke-linejoin:round;stroke-width:16px;}"));
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "frame"
}, React.createElement("rect", {
  className: "frame",
  width: 256,
  height: 256
})), React.createElement("g", {
  id: "white"
}, React.createElement("path", {
  className: "white",
  d: "M214.78,177v27.66a18.44,18.44,0,0,1-18.37,18.52c-.58,0-1.16,0-1.74-.07a182.5,182.5,0,0,1-79.58-28.32,179.67,179.67,0,0,1-55.33-55.33A182.32,182.32,0,0,1,31.45,59.5a18.44,18.44,0,0,1,16.71-20c.54,0,1.09-.07,1.64-.07H77.46A18.44,18.44,0,0,1,95.91,55.26a118.71,118.71,0,0,0,6.45,25.91,18.42,18.42,0,0,1-4.15,19.46L86.5,112.34a147.61,147.61,0,0,0,55.33,55.33L153.54,156A18.46,18.46,0,0,1,173,151.81a118.68,118.68,0,0,0,25.92,6.46A18.44,18.44,0,0,1,214.78,177Z"
})), React.createElement("g", {
  id: "highlights"
}, React.createElement("path", {
  className: "highlights",
  d: "M211.29,206.61c-88.48,0-160.21-65-160.21-145.1A131.23,131.23,0,0,1,52.7,40.8H48.54c-.56,0-1.1,0-1.66.08A18.59,18.59,0,0,0,30,61.06a183.9,183.9,0,0,0,28.54,80.58,181.09,181.09,0,0,0,55.77,55.77A183.94,183.94,0,0,0,194.55,226c.59,0,1.17.07,1.75.07a18.6,18.6,0,0,0,18.52-18.67v-.77C213.64,206.6,212.47,206.61,211.29,206.61Z"
})), React.createElement("g", {
  id: "primary"
}, React.createElement("path", {
  className: "primary",
  d: "M214.78,178.43V206.1a18.45,18.45,0,0,1-18.37,18.52c-.58,0-1.16,0-1.74-.08a182.49,182.49,0,0,1-79.58-28.31A179.88,179.88,0,0,1,59.76,140.9a182.36,182.36,0,0,1-28.31-80,18.43,18.43,0,0,1,16.71-20c.54-.05,1.09-.08,1.64-.08H77.46A18.45,18.45,0,0,1,95.91,56.7a118.66,118.66,0,0,0,6.45,25.92,18.4,18.4,0,0,1-4.15,19.45L86.5,113.79a147.68,147.68,0,0,0,55.33,55.33l11.71-11.72A18.44,18.44,0,0,1,173,153.26a118.66,118.66,0,0,0,25.92,6.45A18.45,18.45,0,0,1,214.78,178.43Z"
}), React.createElement("path", {
  className: "primary",
  d: "M150.69,68.51a46.1,46.1,0,0,1,36.42,36.42"
}), React.createElement("path", {
  className: "primary",
  d: "M150.69,31.62A83,83,0,0,1,224,104.84"
})));
var SvgPhoneCall = function SvgPhoneCall(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, ["svgRef", "title"]);
  return React.createElement("svg", _extends({
    viewBox: "0 0 256 256",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2, _ref3);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPhoneCall, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/PhoneCall.77f2af37.svg";
export { ForwardRef as ReactComponent };